if ($.isFunction($.fn.scrollspy)) {
  $('body').scrollspy({ target: '#timelineNav', offset: 200 })

  $(window).on('activate.bs.scrollspy', function (e, obj) {
    const navItem = $('[href="' + obj.relatedTarget+ '"]')
    if (navItem.length <= 0) {
      return; // exit function if elem doesn't exist
    }
    const left = navItem.offset().left;
    const width = navItem.outerWidth();
    // Need div with :before:after
    // Change text of sed div to text of navitem
    // Have navitem have no indication of active change

    navItem.parent().parent().prev().css({
      left: left,
      width: width,
    }).fadeIn();

  })
}